type OwnArgs = {
  isActiveTrade: boolean;
  isTradeInApplied: boolean;
  shouldShowWSYS: boolean;
  tradeIncentive?: number;
};

export default function shouldShowTradeIncentive({
  isActiveTrade,
  isTradeInApplied,
  shouldShowWSYS,
  tradeIncentive
}: OwnArgs): boolean {
  const hasTradeIncentive = (tradeIncentive ?? 0) > 0;

  const shouldShowTreatment =
    shouldShowWSYS && isTradeInApplied && isActiveTrade;

  return shouldShowTreatment && hasTradeIncentive;
}
